<template>
<div>
   <CHeader
      data-aos-easing="linear"
      data-aos-duration="1500"
      class="navbars"
      :class="{ 'navbar--hidden': !showNavbar }"
    >
      <CHeaderBrand class="mx-auto" to="/home">
        <img
          src="../assets/img/pickiddologolargesizewhite.png"
          height="48px"
          class="m-2"
        />
      </CHeaderBrand>

      <CDropdown color="light" class="m-2 d-sm-flex d-lg-none" :caret="false">
        <template #toggler-content>
          <CIcon name="cil-justify-center" />
        </template>
        <CDropdownItem to="/Package">PRICING</CDropdownItem>
        <CDropdownItem href="https://www.pickiddo.com/JoinClass"
          >JOIN CLASS</CDropdownItem
        >

        <CDropdownItem href="https://www.pickiddo.com/SearchTutor">
          <CButton color="danger" size="sm" shape="pill"
            >REGISTER</CButton
          ></CDropdownItem
        >
        <CDropdownItem href="https://pickiddo.com/OnlineClass/#/Login">
          <CButton color="success" size="sm" shape="pill"
            >SIGN IN</CButton
          ></CDropdownItem
        >
      </CDropdown>

      <CHeaderNav class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3"> </CHeaderNavItem>
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/"> HOMEPAGE </CHeaderNavLink>
        </CHeaderNavItem>
        <!-- <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/about" exact>
            ABOUT US
          </CHeaderNavLink>
        </CHeaderNavItem> -->
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/Package">
            PRICING
          </CHeaderNavLink>
        </CHeaderNavItem>
        <!-- <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/SearchTutor">
            REGISTER
          </CHeaderNavLink>
         </CHeaderNavItem> -->
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink
            style="color: #fff"
            href="https://www.pickiddo.com/JoinClass"
          >
           JOIN CLASS
          </CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem class="px-3 ml-3">
          <CHeaderNavLink href="https://www.pickiddo.com/SearchTutor">
            <CButton color="danger" size="sm" shape="pill"
              >REGISTER</CButton
            ></CHeaderNavLink
          >
        </CHeaderNavItem>
        <CHeaderNavItem class="px-3 ml-3">
          <CHeaderNavLink href="https://pickiddo.com/OnlineClass/#/Login">
            <CButton color="success" size="sm" shape="pill"
              >SIGN IN</CButton
            ></CHeaderNavLink
          >
        </CHeaderNavItem>
      </CHeaderNav>
    </CHeader>
      <br /><br /><br />
    <CContainer>
        <CRow class="">
            <CCol style="max-width:100%" sm="12" class="mt-5 justify-content-center">
                <h5 class="display-5">Add Quiz Available</h5>
       <CCard class="p-3">
            Select Quiz
           <v-select
                                  ref="select"
                                  v-model="SelectedQuiz"
                                  :options="quiz"
                                  label="Title"
                                  placeholder="--Please Select Quiz Title--"
                                  required
                                />
                                <br /> 
                                Quiz Description
                                  <tinymce
                  id="d1"
                  v-model="QuizDescription"
                  placeholder="Enter Your Description"
                ></tinymce>

                                  <br /> 
                                Choose Image Banner
                                <input
                type="file"
                id="app"
                ref="myapp"
                @change="onFileChangeUploadPhoto"
                accept="image/x-png, image/gif, image/jpeg"
              />
               <br /> 
                <br /> 
              <CButton type="button" @click="SubmitQuiz" color="success">Submit</CButton>
        </CCard>
            </Ccol>
        </CRow>
    </CContainer>

      <CModal title="Success" size="sm" color="success" :show.sync="successModal">
      <CCol sm="12" class="text-center">
        <div class="text-center">
          <img class="m-0" width="100px" src="../assets/img/iconsuccess.png" />
        </div>
      </CCol>

      <CCol sm="12">
        <label class="text-center m-0"
          >You have successfully save class package.</label
        >
      </CCol>
    </CModal>

    <CModal title="Error" size="sm" color="danger" :show.sync="errorModal">
      <CCol sm="12" class="text-center">
        <div class="text-center">
          <img class="m-0" width="100px" src="../assets/img/iconerror.png" />
        </div>
      </CCol>

      <h3 class="text-center">ERROR !</h3>
      <CCol sm="12">
        <label class="text-center m-0">Data Already Exist</label>
      </CCol>
    </CModal>
</div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import backgroundBanner from "../assets/img/bgApps.jpg";
import tinymce from "vue-tinymce-editor";
Vue.component("tinymce", tinymce);



Vue.use(VuejsDialog);
export default {
  name: "Login",
  data() {
    return {
      backgroundBanner,
      quiz: [],
      SelectedQuiz: "",
      QuizDescription: "",

       urlApp: [],
       successModal: false,
       errorModal: false,
    };
  },
  async mounted() {
   this.GetQuiz();
  },
  methods: {
    async GetQuiz() {
      return this.$API
        .get(this.$AllQuizList)
        .then(
          function (response) {
            this.quiz = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
     onFileChangeUploadPhoto(e) {
      const file = e.target.files[0];
      this.urlApp = URL.createObjectURL(file);
      this.HandleFileInputPhoto();
    },
     HandleFileInputPhoto() {
      this.photo = this.$refs.myapp.files;
      this.SubmitFilePhoto();
    },
     async SubmitFilePhoto() {
      const formData = new FormData();

      formData.append("file", this.photo[0]);
      formData.append("QuizTitleId", this.SelectedQuiz.Id);

      this.$API
        .post(this.$UploadTuitionQuiz, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.imageId = response.data;
          }
        })
        .catch((error) => {
          console.log("Upload failed.");
          console.log(error);
        });
    },

    SubmitQuiz()
    {    
      const formData = new FormData();

      formData.append("QuizTitleId", this.SelectedQuiz.Id);
       formData.append("QuizDescription", this.QuizDescription);
      formData.append("QuizImageId", this.imageId);

     

      return this.$API
        .post(this.$InsertTuitionQuiz, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (
            response.status == 200 &&
            response.data != null &&
            response.data > 0
          ) {
            this.successModal = true;
          } else {
            this.errorModal = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });

    }
  },
};
</script>


<style>
body {
  background: #fff;
}
.carousel-indicators li {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #000015;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  -webkit-transition: opacity 0.6s ease;
  transition: opacity 0.6s ease;
}

.custom-font {
  font-family: "Rubik", sans-serif;
}

.change_color {
  background-color: red;
}

* {
  padding: 0;
  margin: 0;
}

body {
  height: 100vh;
}
body nav {
  position: fixed;
  width: 100%;
  height: 70px;
  background-color: transparent;
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
}
body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}

.c-header {
  background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83;
  /* color: #fff; */
}

@import url("https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap");
</style>
